import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator";
/** @internal */ export const cameraValidator = T.model("camera", T.object({
    typeName: T.literal("camera"),
    id: idValidator("camera"),
    x: T.number,
    y: T.number,
    z: T.number,
    meta: T.jsonValue
}));
/** @internal */ export const cameraVersions = {
    AddMeta: 1
};
/** @internal */ export const cameraMigrations = defineMigrations({
    currentVersion: cameraVersions.AddMeta,
    migrators: {
        [cameraVersions.AddMeta]: {
            up: (record)=>{
                return {
                    ...record,
                    meta: {}
                };
            },
            down: ({ meta: _, ...record })=>{
                return {
                    ...record
                };
            }
        }
    }
});
/** @public */ export const CameraRecordType = createRecordType("camera", {
    validator: cameraValidator,
    migrations: cameraMigrations,
    scope: "session"
}).withDefaultProperties(()=>({
        x: 0,
        y: 0,
        z: 1,
        meta: {}
    }));
